
const ErrorIcon = () => {
  return null;
};

export default ErrorIcon;
